<template>
  <div class="content-box">
    <Header></Header>
    <div class="join-content max-w">
      <div class="back" @click="$router.push(`/${schoolcode}/student`)">
        返回
      </div>
      <div class="class-title">加入班级记录</div>
      <div class="class-table">
        <table>
          <thead>
            <tr>
              <th>班级名称</th>
              <th>负责老师</th>
              <th>所属实践活动</th>
              <th>加入时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, ind) in joinList" :key="ind">
              <td>{{ item.class_name }}</td>
              <td>{{ item.teacher_name }}</td>
              <td>{{ item.activity_name }}</td>
              <td>{{ item.created_at }}</td>
              <td class="join" @click="toMyClass(item)">进入班级</td>
            </tr>
          </tbody>
        </table>
      </div>
      <a-pagination
        v-if="total > pageSize"
        v-model="memberPage"
        :total="total"
        :page-size="pageSize"
        show-less-items
        @change="MemberChange"
      />
    </div>
    <loading v-if="loading"></loading>
  </div>
</template>

<script>
import services from "../../assets/js/services.js";
import Header from "../../components/Header.vue";
import loading from "../../components/loading.vue";
export default {
  data() {
    return {
      schoolcode: localStorage.getItem("schoolCode"),
      joinList: [],
      memberPage: 0,
      total: 0,
      pageSize: 10,
      loading: false,
    };
  },
  components: {
    Header,
    loading,
  },
  created() {
    this.getJoinRecord(1);
  },
  methods: {
    async getJoinRecord(page) {
      this.loading = true;

      this.memberPage = page;
      let res = await services.getJoinRecord({
        page: this.memberPage,
        size: this.pageSize,
      });
      console.log(res);
      if (res.code == "0000") {
        this.joinList = res.data.items;
      }
      this.loading = false;
    },
    //我的班级
    toMyClass(item) {
      this.$router.push({
        path: `/${this.schoolcode}/student/myClass`,
        query: {
          classes: item.class_id,
          activity_id: item.activity_id,
        },
      });
    },
    MemberChange(page) {
      this.getJoinRecord(page);
    },
  },
};
</script>

<style lang="less" scoped>
.content-box {
  padding-top: 54px;
  .join-content {
    margin: 0 auto;
    padding-top: 16px;
    .back {
      width: 80px;
      height: 32px;
      cursor: pointer;
      background: #b84b3c;
      border-radius: 16px;
      font-weight: bold;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      line-height: 32px;
      &::before {
        content: "<";
        margin-right: 5px;
      }
    }
    .class-info {
      margin-top: 16px;
      height: 40px;
      background: linear-gradient(90deg, #ffefcc 0%, #ffebd3 100%);
      border-radius: 4px 4px 0px 0px;
      line-height: 40px;
      display: flex;
      padding: 0 25px;
      .practice-name {
        font-weight: bold;
        font-size: 16px;
        color: #6f4113;
        margin-right: 19%;
      }
      .class-name {
        font-weight: bold;
        font-size: 14px;
        color: #373536;
      }
      .class-teach {
        font-weight: bold;
        font-size: 14px;
        color: #373536;
        margin-left: 8%;
      }
    }
    .class-title {
      font-weight: bold;
      font-size: 14px;
      color: #373536;
      text-align: center;
      letter-spacing: 5px;
      margin-top: 20px;
    }
    .class-table {
      margin-top: 21px;
      table {
        width: 100%;
        thead {
          tr {
            background: #f8f8f8;
            th {
              padding: 0 24px;
              font-weight: bold;
              font-size: 14px;
              color: #2f2626;
              height: 36px;
              text-align: center;
            }
          }
        }
        tbody {
          tr {
            border-bottom: 1px solid #ecedef;
            td {
              font-size: 14px;
              color: #717479;
              line-height: 36px;
              padding: 0 24px;
              text-align: center;
              &.join {
                color: #b84b3c;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
}
</style>